import { render, staticRenderFns } from "./RedemptionDetail.vue?vue&type=template&id=6fe1b38a"
import script from "./RedemptionDetail.vue?vue&type=script&lang=js"
export * from "./RedemptionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports